import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginData } from '@public-up/interface';
import { environment } from '@up/environment';
import { Observable } from 'rxjs';
import { AeStorageService } from '@extranet/services/storage-service';

@Injectable({
  providedIn: 'root'
})
export class AeAuthService {
  constructor(
    private readonly aeStorageService: AeStorageService,
    private readonly http: HttpClient
  ) {}

  public isLogged = false;
  public loginData: LoginData;

  public login(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post(environment.apiUrl + '/extranet/auth/login', credentials);
  }

  public reset(credentials: { password: string; token: string }): Observable<any> {
    return this.http.put(environment.apiUrl + '/extranet/auth/reset', credentials);
  }

  public sendReset(credentials: { email: string; type: string }): Observable<any> {
    return this.http.post(environment.apiUrl + '/extranet/auth/send-reset-email', credentials);
  }

  public renew(): Observable<any> {
    return this.http.get(environment.apiUrl + '/extranet/auth/renew');
  }

  public tokenProspect(credentials: { token: string }): Observable<any> {
    return this.http.get(environment.apiUrl + '/extranet/auth/token-prospect?token=' + credentials.token);
  }

  public getLoginStorage(): void {
    const loginData = this.aeStorageService.isLogged();
    if (!loginData) {
      return;
    } else {
      this.loginData = loginData;
      this.isLogged = true;
    }
  }

  public logout(): void {
    this.http.delete(environment.apiUrl + '/extranet/auth/logout').subscribe();
    this.aeStorageService.removeLocal('ae-login');
    this.loginData = undefined;
    this.isLogged = false;
  }
}
